import type { AttachmentGroup } from "@/components/AttachmentsDisplaySection";
import type { ContestAgreementFile } from "@/types/contestAgreement";
import { FILE_TYPE_ORDER } from "@/types/contestAgreement";

export function mapContestAgreementFilesToAttachmentGroups(
  files: ContestAgreementFile[],
  getTitle: (fileType: string) => string,
): AttachmentGroup[] {
  return FILE_TYPE_ORDER.flatMap((fileType) => {
    const groupFiles = files.filter((f) => f.type === fileType);
    if (!groupFiles.length) return [];
    return [
      {
        key: fileType,
        title: getTitle(fileType),
        files: groupFiles.map((f) => ({
          filename: f.filename,
          url: f.presigned_url,
          size: String(f.size),
        })),
      },
    ];
  });
}
